module.exports = __webpack_public_path__ + "static/img/2.032d337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-2/2.jpg
// module id = qEAp
// module chunks = 1